<script lang="ts">
  import type { FacetValueLabel, FacetValueLabelOptions } from "./type";

  interface Props extends FacetValueLabel, FacetValueLabelOptions {
    prefix?: string;
    grayPrefix?: boolean;
  }

  let {
    title,
    prefix = "",
    grayPrefix = false,
    itemCount,
    bold = true,
    size = "100",
    showCount = true,
  }: Props = $props();

  itemCount = showCount ? itemCount : undefined;
</script>

<span class={["hc_label", `hc_label--${size}`]} data-count={itemCount}
  ><span class="hc_label__title">
    <span class={[{ "hc_label__title--gray": grayPrefix }]}>{prefix}</span><span
      class={[{ "hc_label__title--bold": bold }]}>{title}</span
    >
  </span></span
>

<style lang="scss">
  .hc_label {
    max-width: 100%;
    display: flex;
    align-items: center;
    gap: var(--oc-semantic-spacing-50);
    overflow: hidden;
    font: var(--label-font);

    &--50 {
      --label-font: var(--oc-semantic-font-copy-50);
    }

    &--75 {
      --label-font: var(--oc-semantic-font-copy-75);
    }

    &--100 {
      --label-font: var(--oc-semantic-font-copy-100);
    }

    &--125 {
      --label-font: var(--oc-semantic-font-copy-125);
    }

    &__title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 0 1 min-content;

      &--bold {
        font-weight: 700;
      }

      &--gray {
        color: var(--oc-semantic-color-text-secondary);
      }
    }

    &[data-count]::after {
      flex: 0 0 max-content;
      color: var(--oc-semantic-color-text-secondary);
      content: "(" attr(data-count) ")";
    }
  }
</style>
